/**
 * Returns a new array of numbers.
 * @param nstart starting integer
 * @param nend upper bound integer (inclusive)
 * @param step 
 * @example Nnary(1, 5) --> [1, 2, 3, 4, 5]
 * @example Nnary(1, 10, 2) --> [1, 3, 5, 7, 9]
 * @example Nnary(10, 1, -3) --> [10, 7, 4, 1]
 */
export default function Nnary(nstart: number, nend: number, step: number = 1): number[] {
    // return [...new Array((nend + 1) - nstart).keys()].slice(nstart);
    const output = [];

    if (step > 0)
        for (let a = nstart; a <= nend; a += step)
            output.push(a);

    if (step < 0)
        for (let a = nstart; a >= nend; a += step)
            output.push(a);

    return output;
}
